export enum CoachEnum {
  COACH_MO = 'coach-mo',
}

// TODO FIX when we implement theming of modules per coach this has to be changed during runtime
// we have to remove this enum and fix the CSS.
// the component gets the image url by theme or by the module metadata
